import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  public onDragOver(event: any) {
    const transfer = event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    if (transfer) {
      transfer.dropEffect = 'none';
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
